import config from '__api/config';
import { batchCollectDrawNum } from '__api/dsbc/inv/batchCollectDrawNum';
import { collectDrawNum } from '__api/dsbc/inv/collectDrawNum';
import { getInvDetailList, InvTaskResVO } from '__api/dsbc/inv/getInvDetailList';
import { ApiHasErrorMessage } from '__constants/http';
import { RootSiblingContainer } from 'emrn-design';
import { Dialog } from 'emrn-design/Dialog';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { Toast } from 'emrn-design/Toast';
import { rpx } from 'emrn-design/rpx';
import { Passport } from 'emrn-hybrid/Passport';
import { EmPageProps } from 'emrn-navigation';
import { AnimatedHeader } from 'emrn-navigation/AnimatedHeader';
import React, { Component } from 'react';
import {
  Text,
  View,
  StyleSheet,
  NativeSyntheticEvent,
  NativeScrollEvent,
  Animated,
  ImageBackground,
  RefreshControl,
  FlatList,
} from 'react-native';

/**
 * 状态
 */
interface InviteRankingState {
  /**
   * y轴滑动位移
   */
  scrollY: Animated.Value;
  /**
   * 邀请数据
   * */
  rewardRecordData: InvTaskResVO[];
  /**
   * 是否展示一键领取
   * */
  showOneKeyGet: boolean;
  /**
   * 总条数
   * */
  totalCount: number;
  /**
   *请求数据加载
   * **/
  loading: boolean;
}

export class InviteProcess extends Component<EmPageProps, InviteRankingState> {
  static displayName = 'InviteProcess';
  private toast = React.createRef<Toast>();
  private dialog = React.createRef<Dialog>();
  private pageSize = 10;

  constructor(props: EmPageProps) {
    super(props);
    this.state = {
      scrollY: new Animated.Value(0),
      rewardRecordData: [],
      showOneKeyGet: false,
      totalCount: 0,
      loading: false,
    };
  }
  async componentDidMount() {
    this.getInviteList(false);
  }
  /**单次领取抽奖机会*/
  getOneKeyGet = async (data: InvTaskResVO) => {
    try {
      const { hasLogin } = await Passport.getUserInfo();
      if (!hasLogin) {
        return;
      }
      const res = await collectDrawNum({
        invId: config.invId,
        taskCode: data.taskCode,
        binvUid: data.binvUid,
        projectId: data.projectId,
      });
      if (res && res.IsSuccess) {
        this.toast.current?.show('领取成功，快去抽奖吧！');
        this.getInviteList(false);
      } else {
        this.dialog.current?.show(res.Message || ApiHasErrorMessage, {});
      }
    } catch (e) {
      console.log(e);
    }
  };
  /**批量领取抽奖机会*/
  getOneKeyGetAll = async () => {
    try {
      const { hasLogin } = await Passport.getUserInfo();
      if (!hasLogin) {
        return;
      }
      const res = await batchCollectDrawNum({
        invId: config.invId,
      });
      if (res && res.IsSuccess) {
        this.toast.current?.show('领取成功，快去抽奖吧！');
        this.getInviteList(false);
      } else {
        this.dialog.current?.show(res.Message || ApiHasErrorMessage, {});
      }
    } catch (e) {
      console.log(e);
    }
  };
  /**获取邀请列表*/
  getInviteList = async (loadmore: boolean) => {
    try {
      const { hasLogin } = await Passport.getUserInfo();
      if (!hasLogin || this.state.loading) {
        return;
      }
      if (loadmore && this.state.totalCount > this.pageSize) {
        this.pageSize = this.pageSize + 10;
        this.setState({
          loading: true,
        });
      }
      const res = await getInvDetailList({ invId: config.invId, pageNum: 1, pageSize: this.pageSize });
      this.setState({
        loading: false,
      });
      if (res && res.IsSuccess) {
        this.setState({
          rewardRecordData: res.Data?.list || [],
          showOneKeyGet: res.Data?.collectStatus === '0',
          totalCount: res.Data?.totalCount || 0,
        });
      }
    } catch (e) {
      this.setState({
        loading: false,
      });
      console.log(e);
    }
  };
  onScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { y } = event.nativeEvent.contentOffset;
    Animated.event([{ y: this.state.scrollY }])({ y });
  };
  renderFooter = () => {
    const { loading } = this.state;
    if (loading) {
      return (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Spacer size={rpx(30)} />
          <Text style={{ fontSize: rpx(14 * 2), color: '#666' }}>加载中...</Text>
        </View>
      );
    } else {
      return null;
    }
  };
  render() {
    const styles = createStyles();
    const { scrollY, rewardRecordData, showOneKeyGet } = this.state;
    return (
      <RootSiblingContainer>
        <Animated.ScrollView style={styles.container} bounces={false} scrollEventThrottle={10} onScroll={this.onScroll}>
          <LinearGradient
            colors={['rgba(155, 242, 252,1)', 'rgba(149, 235, 250,1)']}
            start={{ x: 0, y: 0 }}
            end={{ x: 0, y: 3 }}
            style={{ alignItems: 'center' }}
          >
            <ImageBackground
              style={styles.headerBc}
              source={require('../../images/invite/topbg.png')}
              resizeMode={'stretch'}
            />
            <View style={styles.inviteProcess}>
              <View style={styles.inviteRecordContent}>
                <Text style={styles.columnTitle}>任务</Text>
                <Text style={styles.inviteStatusTitle}>邀请状态</Text>
                <Text style={styles.inviteCountTitle}>抽奖次数</Text>
                <Text style={styles.columnBtnTitle} />
              </View>
              <View style={{ flex: 1 }}>
                <FlatList
                  data={rewardRecordData}
                  nestedScrollEnabled
                  onEndReached={() => this.getInviteList(true)}
                  onEndReachedThreshold={0.1}
                  ListFooterComponent={this.renderFooter.bind(this)}
                  keyExtractor={(item, index) => item.binvUid + item.taskCode + index}
                  renderItem={({ item }) => (
                    <View style={styles.wardRecordContent}>
                      <View style={styles.columnReward}>
                        <Text style={styles.columName} numberOfLines={1}>
                          {item.taskName}
                        </Text>
                        <Text style={styles.columPhone}>{item.starPhone}</Text>
                      </View>
                      <Text
                        style={[
                          styles.inviteStatus,
                          item.status === '2'
                            ? styles.redColor
                            : ['0', '1'].includes(item.status)
                            ? styles.blueColor
                            : styles.greenColor,
                        ]}
                      >
                        {item.status === '2' ? '邀请成功' : ['0', '1'].includes(item.status) ? '邀请中' : '邀请失败'}
                      </Text>
                      <Text style={styles.inviteCount}>{item.rewardNum ? '+' + item.rewardNum + '次' : '--'}</Text>
                      <View style={styles.columnRewardTitle}>
                        {item.collectStatus === '0' ? (
                          <LinearGradient colors={['#FE2011', '#FF9073']} style={styles.columnLineBtn}>
                            <EmTouchableOpacity
                              activeOpacity={0.9}
                              onPress={() => {
                                this.getOneKeyGet(item);
                              }}
                            >
                              <Text style={styles.getText}>去领取</Text>
                            </EmTouchableOpacity>
                          </LinearGradient>
                        ) : item.collectStatus === '1' ? (
                          <View style={styles.columnHasGetBtn}>
                            <Text style={styles.getText}>已领取</Text>
                          </View>
                        ) : null}
                      </View>
                    </View>
                  )}
                  ListEmptyComponent={() => {
                    return <Text style={styles.noData}>暂无记录</Text>;
                  }}
                  ItemSeparatorComponent={() => {
                    return <View style={styles.separatorLine} />;
                  }}
                />
              </View>
              {showOneKeyGet ? (
                <EmTouchableOpacity
                  onPress={async () => {
                    this.getOneKeyGetAll();
                  }}
                >
                  <LinearGradient colors={['#FE2011', '#FF9073']} style={styles.getAllCountBtn}>
                    <Text style={styles.getAllText}>一键领取抽奖次数</Text>
                  </LinearGradient>
                </EmTouchableOpacity>
              ) : null}
            </View>
          </LinearGradient>
        </Animated.ScrollView>
        <AnimatedHeader
          title={'邀请进度'}
          scrollY={scrollY}
          titleColor="#333333"
          backTheme={'black'}
          normalBackgroundColor="#7de1f0"
          transparentBackgroundColor="rgba(227,103,38,0)"
        />
        <Toast ref={this.toast} />
        <Dialog ref={this.dialog} />
      </RootSiblingContainer>
    );
  }
}
function createStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: 'rgba(149, 235, 250,1)',
    },
    headerBc: {
      width: rpx(375),
      height: rpx(160),
    },
    inviteProcess: {
      alignItems: 'center',
      height: rpx(700),
      width: rpx(345),
      marginTop: rpx(-70),
      backgroundColor: 'rgba(255, 255, 255,1)',
      borderRadius: rpx(12),
      paddingBottom: rpx(10),
    },
    inviteRecordContent: {
      marginTop: rpx(24),
      alignItems: 'center',
      width: rpx(320),
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: rpx(5),
    },
    columnTitle: {
      width: rpx(90),
      fontSize: rpx(12),
      color: '#999999',
    },
    columnBtnTitle: {
      flex: 1,
    },
    inviteCount: {
      width: rpx(50),
      fontSize: rpx(12),
      color: '#333333',
      textAlign: 'center',
    },
    columnReward: {
      width: rpx(90),
    },
    columName: {
      fontSize: rpx(12),
      color: '#333333',
      fontWeight: 'bold',
    },
    columPhone: {
      fontSize: rpx(11),
      color: '#333333',
      marginTop: rpx(2),
    },
    inviteStatus: {
      width: rpx(80),
      textAlign: 'center',
    },
    inviteStatusTitle: {
      width: rpx(80),
      fontSize: rpx(12),
      color: '#999999',
      textAlign: 'center',
    },
    inviteCountTitle: {
      width: rpx(50),
      fontSize: rpx(12),
      color: '#999999',
      textAlign: 'center',
    },
    columnRewardTitle: {
      marginLeft: rpx(12),
      flex: 1,
      width: rpx(140),
      textAlign: 'center',
      justifyContent: 'center',
    },
    wardRecordContent: {
      height: rpx(60),
      alignItems: 'center',
      width: rpx(320),
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    noData: {
      textAlign: 'center',
      marginTop: rpx(300),
    },
    separatorLine: {
      alignItems: 'center',
      width: rpx(310),
      height: rpx(1),
      backgroundColor: '#eeeeee',
      opacity: 0.5,
    },
    getAllCountBtn: {
      marginTop: rpx(20),
      marginBottom: rpx(20),
      width: rpx(260),
      height: rpx(50),
      borderRadius: rpx(25),
    },
    getAllText: {
      fontSize: rpx(18),
      fontWeight: 'bold',
      color: '#ffffff',
      textAlign: 'center',
      lineHeight: rpx(50),
    },
    columnLineBtn: {
      width: rpx(75),
      height: rpx(30),
      borderRadius: rpx(15),
      alignItems: 'center',
    },
    columnHasGetBtn: {
      width: rpx(75),
      height: rpx(30),
      borderRadius: rpx(15),
      backgroundColor: 'rgba(204, 204, 204,0.8)',
      alignItems: 'center',
    },
    columnBtn: {
      width: rpx(75),
      height: rpx(30),
      borderRadius: rpx(15),
      alignItems: 'center',
      textAlign: 'center',
    },
    getText: {
      textAlign: 'center',
      fontSize: rpx(12),
      color: '#ffffff',
      lineHeight: rpx(30),
    },
    redColor: {
      color: '#FF341E',
    },
    blueColor: {
      color: '#3381E3',
    },
    greenColor: {
      color: '#333333',
    },
  });
}
